import { createSlice } from "@reduxjs/toolkit";

const transactionSlice = createSlice({
    name: "transaction",
    initialState: {
        transactions: [],
    },
    reducers: {
        addTransaction: (state, action) => {
            state.transactions.push(action.payload);
        },
    },
});

export const { addTransaction } = transactionSlice.actions;
export default transactionSlice.reducer;
